import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ICalendarState, RawActions, IEventFilter } from '@adage/ace-calendar';

import Dropdown from '../views/dropdown';
import CheckboxView from '../views/checkbox';
import { IWACEvent, InputOption, ICalendarReduxState } from '../classes';
import { selectFilterOption } from "../redux/actions/index";

interface CheckboxExternalProps {
    properties: InputOption;
    filterKey: string;
    propertyToCompare: string;
}

interface StateToProps {
    checked: boolean;
}

interface CheckboxDispatchProps {
    updateFilter: (matched: boolean) => any;
}

type CheckboxProps = CheckboxExternalProps & StateToProps & CheckboxDispatchProps;

interface CheckboxState {

}

class Checkbox extends React.Component<CheckboxProps, CheckboxState> {
    constructor(props: CheckboxProps) {
        super(props);
    }

    toggled(state: boolean) {
        this.props.updateFilter(state);
    }

    render(): JSX.Element {
        return (
            <CheckboxView properties={this.props.properties} onChange={this.toggled.bind(this)} id={this.props.filterKey} isCheckedOverrideValue={this.props.checked} >
                {
                    this.props.children
                }
            </CheckboxView>
        )
    }
}

function comparison(property: string, expected: boolean) {
    return function (event: IWACEvent) {
        return true;
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>, ownProps: CheckboxProps) {
    return {
        updateFilter: (matched: boolean) => {
            dispatch(selectFilterOption({
                filterKey: ownProps.filterKey, chosenValue: matched.toString()
            }));
            dispatch(RawActions.updateEventFilter({ key: ownProps.filterKey, filter: comparison(ownProps.propertyToCompare, matched) }))
        }
    }
}

function mapStateToProps(state: ICalendarReduxState, externalProps: CheckboxExternalProps) {
    return {
        checked: state.filterModel.dropdownOptions[externalProps.filterKey] === "true"
    }
}

export default connect<StateToProps, CheckboxDispatchProps>(mapStateToProps, mapDispatchToProps)(Checkbox);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/checkbox.tsx